export default "__VITE_ASSET__fc765e4d__"